export const GOOGLE_FONT_LINKS = [
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: '' },
  { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700&display=swap' },
  { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap' },
] as const;

export const isDavisBaconScheduleFixture = (fixtureName = process.env.REACT_APP_E2E_FIXTURE) => fixtureName === 'davis-bacon-schedule';
export const isConstructionCostSnapshotFixture = (fixtureName = process.env.REACT_APP_E2E_FIXTURE) => fixtureName === 'construction-cost-snapshot';
export const isActualComponentQueueFixture = (fixtureName = process.env.REACT_APP_E2E_FIXTURE) => fixtureName === 'actual-component-queue';
export const isLocalOnlyStage623Fixture = (fixtureName = process.env.REACT_APP_E2E_FIXTURE) => (
  isDavisBaconScheduleFixture(fixtureName)
  || isConstructionCostSnapshotFixture(fixtureName)
  || isActualComponentQueueFixture(fixtureName)
);

/** The fixture has a local, system-font stylesheet and never receives remote links. */
export const entryAssetPlan = (fixtureName = process.env.REACT_APP_E2E_FIXTURE) => (
  isLocalOnlyStage623Fixture(fixtureName)
    ? { stylesheet: 'e2e/davisBaconScheduleFixture.css', remoteFonts: [] as typeof GOOGLE_FONT_LINKS[number][] }
    : { stylesheet: 'index.css', remoteFonts: [...GOOGLE_FONT_LINKS] }
);

/**
 * The normal app preserves its existing Sora/Roboto links. They deliberately
 * live here rather than public/index.html so an opt-in fixture can start with
 * no remote-font requests at all.
 */
export const installRemoteApplicationFonts = (target: Document = document) => {
  GOOGLE_FONT_LINKS.forEach((font) => {
    if (target.head.querySelector(`link[data-farchat-font-href="${font.href}"]`)) return;
    const link = target.createElement('link');
    link.rel = font.rel;
    link.href = font.href;
    link.dataset.farchatFontHref = font.href;
    if ('crossOrigin' in font) link.setAttribute('crossorigin', font.crossOrigin);
    target.head.appendChild(link);
  });
};
